import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTipoPedidoEstabClassifiscClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/tipo-pedido-estab-classifisc');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async findTipopedidoEndEstabelecimento(queries = {}) {
    try {
      const response = await this.api.post('/tipo-pedido-estab-classifisc/findTipopedidoEndEstabelecimento', { params: queries });
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab Classifisc');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/tipo-pedido-estab-classifisc', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/tipo-pedido-estab-classifisc', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Pedido Estab');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/tipo-pedido-estab-classifisc/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pedido Estab');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/tipo-pedido-estab-classifisc/', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Pedido Estab');
    }
  }

  async destroy(data) {
    try {
      const { data: response } = await this.api.post('/tipo-pedido-estab-classifisc/delete', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }
}
